import React, { useEffect } from 'react'
import './CreditPayment.css';
export default function PaymentSuccess() {

    useEffect(() => {
        setTimeout(() => {
            window.location = "/aidata?selected=5";
            // navigate('/');
            //     window.location.reload();
        }, 3000); //miliseconds
    }, []);

    return (
        <div className='payment_container'>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "40vh" }}>
                <img alt="loader" src="/assets/psuccess.gif" height={350} width={400} />
            </div>
        </div>
    )
}
